export default __webpack_public_path__ + "static/media/notes.80862aa2.svg";